interface ICreateMessageRoomByClientRequest {

    projectId?: string;
    opponentId?: string;

}
class CreateMessageRoomByClientRequest implements ICreateMessageRoomByClientRequest {

    public projectId: string;
    public opponentId: string;

}

interface ISendMessageByClientRequest {

    text?: string;
    projectId?: string;
    opponentId?: string;
    uploadFile?: File | null;

}
class SendMessageByClientRequest implements ISendMessageByClientRequest {

    public text: string;
    public projectId: string;
    public opponentId: string;
    public uploadFile: File | null;

}

interface ICreateMessageRoomByCustomerRequest {

    projectId?: string;
    opponentId?: string;

}
class CreateMessageRoomByCustomerRequest implements ICreateMessageRoomByCustomerRequest {

    public projectId: string;
    public opponentId: string;
}

interface ISendMessageByCustomerRequest {

    text?: string;
    projectId?: string;
    opponentId?: string;
    uploadFile?: File | null;

}

class SendMessageByCustomerRequest implements ISendMessageByCustomerRequest {

    public text: string;
    public projectId: string;
    public opponentId: string;
    public uploadFile: File | null;

}

export {
    CreateMessageRoomByClientRequest,
    SendMessageByClientRequest,

    CreateMessageRoomByCustomerRequest,
    SendMessageByCustomerRequest,
}



// WEBPACK FOOTER //
// ./src/presentation/request/message_room_request.ts